import * as tooltips from "./tooltips";
import GeoJSONPointsCollection from "../../../../components/maps/GeoJSONMap/GeoJSONPointsCollection";
import React from "react";
import * as markers from "./markers";

const model1ParameterAPIName = {
    'hs': 'hs_avg',
    'hn': 'hn_avg',
    'ta': 'ta_avg',
    't_min': 't_min_avg',
    't_max': 't_max_avg',
    'th30': 'th30_avg',
    'th10': 'th10_avg',
    't_gradient': 't_gradient_avg'
}

const Models1Layer = ({webgis}) => {
    const {layersState, featuresState} = webgis;
    const {
        model1StationsGeoJSON,
        geoModel1StationsQuery,
        model1SelectedState,
        webgisRegistryQuery,
        contrastColorsHash
    } = featuresState;
    const {layers} = layersState;

    const registry = webgisRegistryQuery.data ?? {};
    const layerRegistry = registry["models1"];

    const model1StationsGeoJSONDataUpdatedAt = geoModel1StationsQuery.dataUpdatedAt;
    const models1ClusterGroupKey = `model1ClusterGroup-${layers.model1Stations.visibleParam}-${model1StationsGeoJSONDataUpdatedAt}`;

    const models1MarkerIconFn = (feature) => {
        const param = layers.model1Stations.visibleParam;
        const apiParam = model1ParameterAPIName[param];
        const value = feature.properties?.[apiParam];

        const colorCode = markers.getColorForValue(value, param, layerRegistry);
        const textColor = contrastColorsHash[colorCode] ?? '#ffffff';

        const isSelected = model1SelectedState.getSelectedFeatures().some(f => f.id === feature.id);

        return markers.model1Marker({feature, value, colorCode, isSelected, textColor});
    }

    const models1ClusterIconFn = (cluster) => {
        const param = layers.model1Stations.visibleParam;
        const apiParam = model1ParameterAPIName[param];

        const averageValue = cluster.getAllChildMarkers().reduce((sum, marker) => {
            const markerValue = marker.options.feature?.properties?.[apiParam];
            if (markerValue !== undefined && markerValue !== null) {
                return sum + markerValue;
            } else {
                return sum
            }
        }, 0)

        let value = null;
        if (cluster.getChildCount() > 0) {
            value = averageValue / cluster.getChildCount();
        }

        const colorCode = markers.getColorForValue(value, param, layerRegistry);
        const textColor = contrastColorsHash[colorCode] ?? '#ffffff';
        return markers.model1Cluster({cluster, colorCode, value, textColor})
    }

    return <GeoJSONPointsCollection featureCollection={model1StationsGeoJSON}
                                    cluster
                                    getSelectedFeatures={model1SelectedState.getSelectedFeatures}
                                    onFeatureClick={webgis.handleModel1Click}
                                    renderFeatureTooltip={tooltips.renderModel1Tooltip}
                                    markerIconFn={models1MarkerIconFn}
                                    clusterIconFn={models1ClusterIconFn}
                                    clusterGroupProps={{key: models1ClusterGroupKey}}
    />
}

export default Models1Layer;